export default __webpack_public_path__ + "static/google-play-1ef310ff51bfa64975083f7c2f3fde66.jpg";